"use strict";

/**
 * KeyCode
 *
 * Map of common (non-printable) keycodes for the `keydown` and `keyup` events.
 * Note that `keypress` handles things differently and may not return the same
 * values.
 */
module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-typeahead/lib/constants/keyCode.js
 ** module id = 143
 ** module chunks = 0
 **/